import auth from './auth'
import booking from './booking'
import document from './document'
import job from './job'
import log from './log'
import resource from './resource'
import sequence from './sequence'
import support from './support'

const config = {
  modules: {
    auth,
    booking,
    document,
    job,
    log,
    resource,
    sequence,
    support,
  },
}

export default config
